import { LiveTvRowDataModel } from '@modules/entertainment/models/live-tv.models';
import { CallStateEnum } from '@shared/models/call-state.model';
import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature';
import { TableState } from '@store/table-store/table.model.ts';

export interface LiveTvActionParams {
  data?: LiveTvRowDataModel;
  id?: any;
  state?: TableState;
  handleClose?: () => void;
}
export interface LiveTvState extends CallStateMethods {
  callState: CallStateEnum;
  categoryCallState: CallStateEnum;
  channelStatusCallState: CallStateEnum;
  categoryList: any[];
  createRow: (params: LiveTvActionParams) => void;
  createCategory: (params: { data: any; handleClose?: () => void }) => void;
  editCategory: (params: {
    data: any;
    id: any;
    handleClose?: () => void;
  }) => void;
  deleteCategory: (params: LiveTvActionParams) => void;
  getCategoryList: () => void;
  editRow: (params: LiveTvActionParams) => void;
  deleteRow: (params: {
    id: string | string[];
    state: any;
    handleClose?: () => void;
  }) => void;
  importInternetProvider: (params: {
    data: { name: string; apiKey: string };
    state: TableState;
    handleClose?: () => void;
  }) => void;
  importM3u: (params: {
    data: { playlistUrl: string };
    handleClose?: () => void;
    state: TableState;
  }) => void;
  enableChannelsMany: (params: {
    ids: string[];
    state: any;
    handleClose?: () => void;
  }) => void;
  disableChannelsMany: (params: {
    ids: string[];
    state: any;
    handleClose?: () => void;
  }) => void;
  enableAllChannels: (params: { state: any; handleClose?: () => void }) => void;
  disableAllChannels: (params: {
    state: any;
    handleClose?: () => void;
  }) => void;
  isChannelStatusLoading: () => boolean;
  isCategoryLoading: () => boolean;
  isCategoryLoaded: () => boolean;
  isCategoryError: () => boolean;
}

interface LiveTvStateMethods extends CallStateMethodNames {
  createRow: 'createRow';
  editRow: 'editRow';
  deleteRow: 'deleteRow';
  createCategory: 'createCategory';
  editCategory: 'editCategory';
  deleteCategory: 'deleteCategory';
  getCategoryList: 'getCategoryList';
  isChannelStatusLoading: 'isChannelStatusLoading';
  isCategoryLoading: 'isCategoryLoading';
  isCategoryLoaded: 'isCategoryLoaded';
  isCategoryError: 'isCategoryError';
  importInternetProvider: 'importInternetProvider';
  importM3u: 'importM3u';
  enableChannelsMany: 'enableChannelsMany';
  disableChannelsMany: 'disableChannelsMany';
  enableAllChannels: 'enableAllChannels';
  disableAllChannels: 'disableAllChannels';
}

export const LIVE_TV_INITIAL_STATE: Omit<
  LiveTvStateMethods,
  keyof LiveTvState
> = {
  categoryList: [],
  callState: CallStateEnum.Init,
  categoryCallState: CallStateEnum.Init,
  channelStatusCallState: CallStateEnum.Init
};
